import request from '@/utils/request'

export function getPastPaperYearStatus(userId, repoId) {
  return request({
    url: '/past-paper-records/year-status',
    method: 'get',
    params: { userId, repoId }
  })
}

export function getPastPaperByYear(userId, repoId, year) {
  return request({
    url: '/past-paper-records/by-year',
    method: 'get',
    params: { userId, repoId, year }
  })
}

export function startPastPaperExam(data) {
  return request({
    url: '/past-paper-records/start',
    method: 'post',
    data
  })
}

export function finishPastPaperExam(data) {
  return request({
    url: '/past-paper-records/finish',
    method: 'post',
    data
  })
}

export function updatePastPaperRecord(data) {
  return request({
    url: '/past-paper-records/update',
    method: 'put',
    data
  })
}

export function deletePastPaperByUserAndRepo(userId, repoId) {
  return request({
    url: `/past-paper-records/user/${userId}/repo/${repoId}`,
    method: 'delete'
  })
}

export function deletePastPaperByYear(userId, repoId, year) {
  return request({
    url: `/past-paper-records/user/${userId}/repo/${repoId}/year/${encodeURIComponent(year)}`,
    method: 'delete'
  })
}

export function deletePastPaperById(id) {
  return request({
    url: `/past-paper-records/${id}`,
    method: 'delete'
  })
}

export function listPastPaperRecords(userId, repoId) {
  return request({
    url: '/past-paper-records/list',
    method: 'get',
    params: { userId, repoId }
  })
}
